import { useState } from 'react';

import { Button, Input, Select } from '@src/components/ui';

import { fullName, useRoleLabel } from './bits';
import { Modal } from './controls';
import { Field } from './fields';


/** Transfer ownership modal — pick an active non-owner member, then type the
 * org name to confirm. Extracted from Security.jsx (T16). */
function TransferModal({ orgName, members, busy, error, onSubmit, onClose }) {
  const roleLabel = useRoleLabel();
  const [membershipId, setMembershipId] = useState('');
  const [confirm, setConfirm] = useState('');

  const matches = confirm.trim() === orgName;

  return (
    <Modal
      title="Transfer ownership"
      subtitle="The new owner gains full control, including billing. You become a Manager."
      onClose={onClose}
      footer={(
        <>
          <Button type="button" variant="ghost" onClick={onClose}>
            Cancel
          </Button>

          <Button
            type="button"
            disabled={!membershipId || !matches}
            loading={busy}
            onClick={() => onSubmit({ membership_id: membershipId, confirm_name: confirm.trim() })}
          >
            Transfer
          </Button>
        </>
      )}
    >
      <Field label="New owner">
        <Select
          value={membershipId}
          onChange={(event) => setMembershipId(event.target.value)}
        >
          <option value="">Select a member…</option>

          {members.map((member) => (
            <option key={member.id} value={member.id}>
              {`${fullName(member.user) || member.user?.email} · ${roleLabel(member.role)}`}
            </option>
          ))}
        </Select>
      </Field>

      <Field hint={`· ${orgName}`} label="Type the org name to confirm" error={error}>
        <Input
          value={confirm}
          invalid={Boolean(error)}
          placeholder={orgName}
          onChange={(event) => setConfirm(event.target.value)}
        />
      </Field>
    </Modal>
  );
}

TransferModal.displayName = 'TransferModal';


/** Delete organization modal — typed org-name confirmation, danger styling.
 * Extracted from Security.jsx (T16). */
function DeleteOrgModal({ orgName, busy, error, onSubmit, onClose }) {
  const [confirm, setConfirm] = useState('');
  const matches = confirm.trim() === orgName;

  return (
    <Modal
      title="Delete organization"
      subtitle="Permanently removes the org and all its inventory, listings, sales, and team. Cannot be undone."
      onClose={onClose}
      footer={(
        <>
          <Button type="button" variant="ghost" onClick={onClose}>
            Cancel
          </Button>

          <Button
            type="button"
            variant="danger"
            disabled={!matches}
            loading={busy}
            onClick={() => onSubmit({ confirm_name: confirm.trim() })}
          >
            Delete organization
          </Button>
        </>
      )}
    >
      <Field hint={`· ${orgName}`} label="Type the org name to confirm" error={error}>
        <Input
          value={confirm}
          invalid={Boolean(error)}
          placeholder={orgName}
          onChange={(event) => setConfirm(event.target.value)}
        />
      </Field>
    </Modal>
  );
}

DeleteOrgModal.displayName = 'DeleteOrgModal';


export { DeleteOrgModal, TransferModal };
